import { Component, Input } from '@angular/core';
import { TileComponent } from '../tile/tile.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'gbc-error-tile',
    templateUrl: './error-tile.component.html',
    styleUrls: ['./error-tile.component.scss'],
    imports: [TileComponent, TranslateModule]
})
export class ErrorTileComponent {
  @Input()
  public title: string;

  @Input()
  public message: string;

  constructor() {}
}
